
var baseUrl = window.location.hostname;
var env = {};
if (baseUrl === "scgchem-wastemgnt.scg.com") {
    env = {
        REACT_APP_BASE_NAME: null,
        REACT_APP_BASE_URL: 'https://scgchem-wastemgnt.scg.com',
        REACT_APP_API_BASE_URL: 'https://scgchem-bizlogic.scg.com/wastemgnt',
        REACT_APP_ENVIROMENT: null
    };
}
else if (baseUrl === "scgchem-wastemgntqa.scg.com") {
    env = {
        REACT_APP_BASE_NAME: null,
        REACT_APP_BASE_URL: 'https://scgchem-wastemgntqa.scg.com',
        REACT_APP_API_BASE_URL: 'https://scgchem-bizlogicqa.scg.com/wastemgnt',
        REACT_APP_ENVIROMENT: 'UAT'
    };
}
else if (baseUrl === "scgchem-wastemgntdev.scg.com") {
    env = {
        REACT_APP_BASE_NAME: null,
        REACT_APP_BASE_URL: 'https://scgchem-wastemgntdev.scg.com',
        REACT_APP_API_BASE_URL: 'https://scgchem-bizlogicdev.scg.com/wastemgnt',
        REACT_APP_ENVIROMENT: 'DEVELOP'
    };
}
else if (baseUrl === "smartworkdev.scg.co.th/pmm/waste/") {
    env = {
        REACT_APP_BASE_NAME: null,
        REACT_APP_BASE_URL: 'https://smartworkdev.scg.co.th/pmm/waste',
        REACT_APP_API_BASE_URL: 'https://smartworkdev.scg.co.th/pmm/waste-api',
        REACT_APP_ENVIROMENT: 'DEVELOP'
    };
}
else if (baseUrl === "localhost") {
    env = {
        REACT_APP_BASE_NAME: null,
        REACT_APP_BASE_URL: 'http://localhost:3000',
        REACT_APP_API_BASE_URL: 'http://localhost/pmm/waste-api',
        REACT_APP_ENVIROMENT: 'DEVELOP',
    };
}
else {
    env = {
        REACT_APP_BASE_NAME: null,
        REACT_APP_BASE_URL: 'http://localhost:3000',
        REACT_APP_API_BASE_URL: 'http://localhost/pmm/waste-api',
        REACT_APP_ENVIROMENT: 'DEVELOP',
    }
}

export default env;
